import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ELearningService} from '../service/e-learning.service';
import {ELearningListItemModel} from '../models/e-learning-list-item.model';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation, fadeOutOnLeaveAnimation, fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {EventsService} from '../../../services/events.service';
import {Subscription} from 'rxjs';
import {AnalyticsService} from '../../../services/analytics.service';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-e-learning-list',
    templateUrl: './e-learning-list.component.html',
    styleUrls: ['./e-learning-list.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})
export class ELearningListComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    pageDate: Array<ELearningListItemModel> = null;
    pageDateValid = false;
    pageDatePromise: Promise<ELearningListItemModel[]> = null;

    eDelegateIdsUpdated = [];

    constructor(
        private router: Router,
        private event: EventsService,
        private analytics: AnalyticsService,
        private eLearningService: ELearningService,
        public userService: UserService
    ) {
        this.subscriptions.push(
            this.event.subscribe('e-learning:registerMyElearningRun', (eDelegateId) => {
                this.pageDateValid = false;
                this.eDelegateIdsUpdated = eLearningService.registeredToRunIds;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('e-learning:getMyElearningReport:forceUpdate', () => this.pageDateValid = false)
        );
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        if (this.pageDate === null || !this.pageDateValid) {
            this.pageDatePromise = this.eLearningService.getMyElearningList();
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('E-learning List');

        if (this.pageDate === null || !this.pageDateValid) {
            this.pageDatePromise.then(data => {
                this.eDelegateIdsUpdated = [];
                this.pageDate = data;
                this.pageDateValid = true;
            });
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
